import React from 'react';
import Image from 'app/components/Image';
import Link from 'next/link';
import { twMerge } from 'utilities/src/twMerge';

interface Props {
  data: {
    title: string;
    description?: string;
    articles: {
      title: string;
      category?: string;
      readingTime: string;
      href: string;
      image: string;
    }[];
  };
  singleColumn?: boolean;
  className?: string;
}

export default function StartHere({
  data: { title, description, articles },
  singleColumn = false,
  className,
}: Props) {
  return (
    <section className={className}>
      <div className={twMerge('flex flex-col gap-16', { 'gap-6': !description })}>
        <div className="flex flex-col gap-1 md:flex-row md:items-end md:justify-between md:gap-4">
          <h2 className="site-display-m text-site-neutrals-900">{title}</h2>
          {description && <p className="site-paragraph-m text-site-neutrals-500">{description}</p>}
        </div>
        <div
          className={twMerge('grid grid-cols-1', {
            'lgS:gap-x-8 mdL:grid-cols-2 gap-6 lg:gap-x-12': !singleColumn,
            'gap-4': singleColumn,
          })}
        >
          {articles.map((article) => (
            <article key={article.href}>
              <Link href={article.href} className="mdS:items-center group flex items-start gap-4">
                <span className="mdS:h-[5.75rem] mdS:w-[10.25rem] relative h-14 w-[6.125rem]">
                  <Image
                    src={article.image}
                    alt=""
                    fill
                    sizes="(min-width: 640px) 11rem, 7rem"
                    className="object-cover"
                  />
                </span>
                <span className="flex flex-1 flex-col gap-1">
                  <span className="site-paragraph-s text-site-neutrals-900 mdS:site-paragraph-m mdS:!font-bold font-bold group-hover:underline">
                    {article.title}
                  </span>
                  <span className="site-paragraph-xs text-site-neutrals-500 mdS:site-paragraph-s flex flex-wrap items-center gap-x-2.5">
                    {article.category && <span>{article.category}</span>}
                    {article.category && (
                      <span className="text-site-neutrals-300 mdS:inline hidden font-bold" aria-hidden="true">
                        ·
                      </span>
                    )}
                    <span className="mdS:inline hidden">{article.readingTime}</span>
                  </span>
                </span>
              </Link>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
